module.exports = __webpack_public_path__ + "img/Philips423_arm.7eb4475e.png";